import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FAQS } from '../lib/site';

const FaqSection = ({ limit }: { limit?: number }) => {
  const [open, setOpen] = useState<number | null>(0);
  const faqs = limit ? FAQS.slice(0, limit) : FAQS;

  return (
    <section id="faq" className="py-24 md:py-28 max-w-[1400px] mx-auto px-6">
      <div className="grid lg:grid-cols-[0.9fr_1.4fr] gap-12 lg:gap-20">
        <div className="reveal lg:sticky lg:top-28 self-start">
          <p className="label">Preguntas frecuentes</p>
          <h2 className="font-display font-black uppercase tracking-[-0.02em] text-section-title mt-5">
            Resolvemos tus <em className="font-serifit normal-case font-normal text-clay">dudas</em>
          </h2>
          <p className="mt-6 text-ink-soft leading-relaxed max-w-sm">
            ¿No encuentras tu pregunta? Escríbenos por WhatsApp y te respondemos
            en menos de una hora en horario laboral.
          </p>
          <Link to="/faq" className="btn mt-8 border border-ink text-ink">
            Ver todas las preguntas
          </Link>
        </div>

        <div className="reveal">
          {faqs.map((f, i) => (
            <div key={i} className="faq-item" data-open={open === i}>
              <button
                className="faq-question"
                onClick={() => setOpen(open === i ? null : i)}
                aria-expanded={open === i}
                aria-controls={`faq-answer-${i}`}
              >
                <span>{f.q}</span>
                <span className="faq-icon" aria-hidden="true">+</span>
              </button>
              <div className="faq-answer" id={`faq-answer-${i}`} role="region">
                <div className="faq-answer-inner">
                  <p>{f.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
